<template>
  <div
    data-testid="client-meetings-action-bar"
    class="tw-relative tw-min-h-5"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <div class="tw-flex tw-absolute tw-justify-center tw-w-full -tw-top-4">
      <div
        v-if="hover"
        class="tw-flex tw-justify-center tw-absolute tw-top-6 tw-w-full"
      >
        <hr
          class="
            striped
            tw-absolute
            tw-w-full
            tw-h-[3px]
            tw-bg-sf-neutral-lighter-1
            tw-transition-colors
            tw-z-0
            tw-m-0
          "
        />
        <div
          class="
            tw-bg-sf-neutral-lighter-1
            tw-rounded-lg
            tw-px-1
            tw-py-1
            tw-border
            tw-border-sf-neutral-lighter-1
            tw-flex
            tw-gap-2
            tw-absolute
            tw-z-10
            -tw-top-3.5
          "
        >
          <SfButtonDs variant="secondary" size="sm" @click="$emit('add-title')">
            <i class="fa-solid fa-heading tw-mr-1"></i>
            {{ I18n.t('client_meetings.prepare.add_title') }}
          </SfButtonDs>
          <SfButtonDs variant="primary" size="sm" @click="$emit('add-message')">
            <i class="tw-text-sf-snow fa-solid fa-comment tw-mr-1"></i>
            {{ I18n.t('communication.add_remark') }}
          </SfButtonDs>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { SfButtonDs } from '@silverfin/ui-components'

defineEmits(['add-title', 'add-message'])

const hover = ref(false)
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.striped {
  background: repeating-linear-gradient(
    90deg,
    -color('neutral', 'light-1') 0,
    -color('neutral', 'light-1') 12px,
    transparent 12px,
    transparent 16px
  );
}
</style>
